module.exports = __webpack_public_path__ + "img/about-1.7e2cf2a9.jpg";